module.exports = __webpack_public_path__ + "static/media/liveResult.edd6d742.png";